module.exports = __webpack_public_path__ + "static/media/nirmal-1000.9c959b68.png";